import React from 'react';
import { Box, Grid, useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/styles';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import { getDynamicBorder, getStringProduct } from '../../../utils/utilityFunctions';

const CloseIcon = ({ handleonclick, padding, rightmargin, topmargin }) => {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery((theme) => theme.breakpoints.down('sm'));
  const right = rightmargin || '10px';
  const top = topmargin || '10px'
  return (
    <Grid
      container
      sx={{
        // padding: padding || '0px 16px 0px 0px',
        position: 'absolute',
        right: right,
        top: top,
        [theme.breakpoints.down('sm')]: {
          right: '5px',
          top: '5px'
        },
        [theme.breakpoints.up('xll')]: {
          right: getStringProduct(1.25, right),
          top: getStringProduct(1.25, top)
        },
        [theme.breakpoints.up('xlll')]: {
          right: getStringProduct(1.66, right),
          top: getStringProduct(1.66, top)
        },
        [theme.breakpoints.up('xl4')]: {
          right: getStringProduct(2.46, right),
          top: getStringProduct(2.46, top)
        }
      }}
      justifyContent={'end'}
    >
      <CloseRoundedIcon
        sx={{
          color: theme.palette.border.border,
          border: `2px solid ${theme.palette.border.border}`,
          backgroundColor: theme.palette.background.default,
          borderRadius: '7px',
          cursor: 'pointer',
          [theme.breakpoints.up('xll')]: {
            border: getDynamicBorder(1.25, `2px solid ${theme.palette.border.border}`),
            borderRadius: getStringProduct(1.25, '7px'),
            fontSize: getStringProduct(1.25, '24px')
          },
          [theme.breakpoints.up('xlll')]: {
            border: getDynamicBorder(1.66, `2px solid ${theme.palette.border.border}`),
            borderRadius: getStringProduct(1.66, '7px'),
            fontSize: getStringProduct(1.66, '24px')
          },
          [theme.breakpoints.up('xl4')]: {
            border: getDynamicBorder(2.46, `2px solid ${theme.palette.border.border}`),
            borderRadius: getStringProduct(2.46, '7px'),
            fontSize: getStringProduct(2.46, '24px')
          },
        }}
        onClick={handleonclick}
      />
    </Grid>
  );
};

export default CloseIcon;
